import { PROJECTS_NAVIGATION_ITEM } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/action-subject-id.tsx';
import type { ComponentType } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { getMenuItemAnalytics } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/index.tsx';
import type { MenuItemAnalytics } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/types.tsx';

type GetProjectMenuItemAnalyticsArg = Omit<
	MenuItemAnalytics,
	'actionSubjectId' | 'componentType' | 'level'
> & {
	level?: number;
	componentType?: ComponentType;
};

export const getProjectMenuItemAnalytics = ({
	level = 2,
	...attrs
}: GetProjectMenuItemAnalyticsArg): MenuItemAnalytics =>
	getMenuItemAnalytics({
		actionSubjectId: PROJECTS_NAVIGATION_ITEM,
		level,
		// menuId can't be used as itemId, as it has projectKey in it (so it will be different values for different projects).
		...attrs,
	});
